import { api } from 'helpers'
import { ARC_MOSAICO_ENDPOINTS } from 'api/arcMosaico/endpoints'
import type { ParticipantsResponse } from './types'

function assertAuthenticated(response: { status: number }): void {
  if (response.status === 401) {
    window.location.href = '/error_permission'
    throw new Error('Unauthorized')
  }
}

export const fetchProjectParticipants = async (projectId: string): Promise<ParticipantsResponse> => {
  const response = await api.get<ParticipantsResponse>(ARC_MOSAICO_ENDPOINTS.projects.participants(projectId))
  assertAuthenticated(response)
  return response.data
}
